<template>
  <div>
    <el-tabs
      class="glo_tabs"
      type="border-card"
      v-model="activeName"
      @tab-click="tabsClick"
    >
      <!-- =====异常信息===== -->
      <el-tab-pane
        label="异常信息"
        name="one"
      >
        <el-form
          :model="baseInForm"
          ref="baseFormRed"
          label-width="130px"
          class="glo_formBox"
          disabled
        >
          <el-form-item
            label="异常编号:"
            prop="number"
          >
            <el-input
              v-model="baseInForm.number"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="单据类型:"
            prop="documentStatus"
          >
            <el-select
              clearable
              v-model="baseInForm.documentStatus"
              placeholder="请选择"
              @change="changeDocStatus"
            >
              <el-option
                v-for="item in document_Status_list"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="运单号:"
            prop="number"
          >
            <el-input
              v-model="baseInForm.waybillNumber"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item label="运单总件数:">
            <el-input
              v-model="baseInForm.totalCount"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="运单总净重:">
            <el-input
              v-model="baseInForm.totalNetWeight"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="委托客户:">
            <el-input
              v-model="baseInForm.customerName"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="收货客户:">
            <el-input
              v-model="baseInForm.receiveCompany"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="提货日期:">
            <el-input
              v-model="baseInForm.takeTime"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="交货日期:">
            <el-input
              v-model="baseInForm.deliveryTime"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="到站:">
            <el-input
              v-model="baseInForm.arrivalArea"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="外发承运商:">
            <el-input
              v-model="baseInForm.outgoingCarrierName"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="承运商货号:">
            <el-input
              v-model="baseInForm.outgoingNumber"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item
            label="发生时间:"
            prop="happenTime"
          >
            <el-date-picker
              v-model="baseInForm.happenTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="信息来源:">
            <el-input
              v-model="baseInForm.informationSources"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item
            label="异常原因:"
            style="width: 460px"
          >
            <div class="twoInput">
              <el-input
                v-model="baseInForm.exceptionTypeName"
                disabled
              ></el-input>
              <el-input
                v-model="baseInForm.exceptionReason"
                disabled
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="异常范围:">
            <el-input
              v-model="baseInForm.exceptionRange"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item label="责任公司/部门:">
            <el-input
              v-model="baseInForm.liabilityCompany"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item label="是否需要赔款:">
            <el-input
              v-model="baseInForm.isIndemnity==1?'需要':'不需要'"
              disabled
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="异常类型:" prop="exceptionTypeConfDictId">
            <el-select v-model="baseInForm.exceptionTypeConfDictId" placeholder="请选择" clearable @change="changeexceptionTypeName">
              <el-option v-for="item in exception_type_list" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>-->
          <!-- <el-form-item label="来源单号:" prop="documentNumber">
            <el-select clearable filterable v-model="baseInForm.documentNumber" placeholder="请选择" remote :remote-method="getNumbers" @focus="getNumbers()">
              <el-option v-for="(item, index) in wayBillList" :key="index" :label="item.waybillNumber" :value="item.waybillNumber"></el-option>
            </el-select>
          </el-form-item>-->
          <!-- <el-form-item label="外发单号:" prop="outgoingNumber">
            <el-input
              v-model="baseInForm.outgoingNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>-->

          <el-form-item
            label="收款对象:"
            style="width: 460px"
            prop="objectStatusConfDictId"
            v-if="baseInForm.isIndemnity==1"
          >
            <div class="twoInput">
              <el-select
                v-model="baseInForm.objectStatusConfDictId"
                placeholder="请选择"
                @change="changeObjestStatusYS"
                clearable
              >
                <el-option
                  v-for="(item, index) in objectStatusList"
                  :key="index"
                  :label="item.val"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
              <el-select
                v-model="baseInForm.objectName"
                clearable
                remote
                :allow-create="baseInForm.objectStatusConfDictId == 'other'"
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName1"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!-- <el-form-item label="外发承运商:" prop="outgoingCarrierName">
            <el-select
              v-model="baseInForm.outgoingCarrierName"
              placeholder="请选择"
              clearable
              remote
              :remote-method="getCarrierList"
              @change="changeCarrier"
              @focus="getCarrierList()"
            >
              <el-option
                v-for="(item, index) in CarrierLists"
                :key="index"
                :label="item.carrierName"
                :value="item.carrierName"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item
            label="赔付金额:"
            prop="indemnityAmount"
            v-if="baseInForm.isIndemnity==1"
          >
            <el-input
              v-model="baseInForm.indemnityAmount"
              placeholder="请输入"
              clearable
              disabled
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="付款方式:"
            prop="paymentMethodConfDictId"
            v-if="baseInForm.isIndemnity==1"
          >
            <el-select
              v-model="baseInForm.paymentMethodConfDictId"
              placeholder="请选择"
              @focus="getConfDictValDownList('settlement_method')"
            >
              <el-option
                v-for="item in settlement_methodList"
                :key="item.confDictId"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="申请部门:"
            prop="applyDeptId"
            v-if="baseInForm.isIndemnity==1"
          >
            <el-select
              filterable
              clearable
              v-model="baseInForm.applyDeptId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in depList"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="申请人:"
            prop="applyUserId"
            v-if="baseInForm.isIndemnity==1"
          >
            <el-select
              v-model="baseInForm.applyUserId"
              placeholder="请选择"
              @change="changeUserA"
            >
              <el-option
                v-for="item in employeeList"
                :key="item.documentId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="计划处理部门:"
            prop="planHandleDeptId"
          >
            <el-select
              filterable
              clearable
              v-model="baseInForm.planHandleDeptId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in depList"
                :key="item.deptId"
                :label="item.departmentName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="谁跟进:"
            prop="planHandleUserId"
          >
            <el-select
              v-model="baseInForm.planHandleUserId"
              @change="changeUser"
              placeholder="请选择"
            >
              <el-option
                v-for="item in employeeList"
                :key="item.documentId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="计划处理时间:"
            prop="happenTime"
          >
            <el-date-picker
              v-model="baseInForm.planHandleTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="责任人:">
            <el-input
              v-model="baseInForm.liabilityPerson"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="记录人:">
            <el-input
              v-model="baseInForm.recordPerson"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>

          <div
            class="uploadBox"
            style="width:100%;margin-bottom:16px;"
          >
            <div class="uploadItem">
              <div class="uploadLaber">异常图片</div>
              <!-- <uploadimgs
                @input="changeFileList"
                :fileNameLists="fileNameLists"
                :limit="9"
              ></uploadimgs> -->
              <el-image
                v-for="(itemA, idxA) in fileNameLists"
                :key="idxA"
                style="width:150px;height:150px;margin-right:10px;margin-top:10px;"
                :src="itemA.url"
                :preview-src-list="imgsList"
              ></el-image>
            </div>
          </div>
          <el-form-item
            label="创建人:"
            style="width: 320px;"
          >
            <el-input
              v-model="baseInForm.createUserName"
              placeholder="自动带出"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="创建时间:"
            style="width: 320px"
          >
            <el-input
              v-model="baseInForm.createTime"
              placeholder="自动带出"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            class="textArea"
            style="width: 100%"
            label="问题描述:"
            prop="describe"
          >
            <el-input
              type="textarea"
              rows="3"
              placeholder="请输入"
              v-model="baseInForm.describe"
            ></el-input>
          </el-form-item>

          <el-form-item
            class="textArea"
            style="width: 100%"
            label="原因分析:"
            prop="causeAnalysis"
          >
            <el-input
              type="textarea"
              rows="3"
              placeholder="请输入"
              v-model="baseInForm.causeAnalysis"
            ></el-input>
          </el-form-item>

          <el-form-item
            class="textArea"
            style="width: 100%"
            label="改善措施:"
            prop="handleProposal"
          >
            <el-input
              type="textarea"
              rows="3"
              placeholder="请输入"
              v-model="baseInForm.handleProposal"
            ></el-input>
          </el-form-item>

          <el-form-item
            class="textArea"
            style="width: 100%"
            label="完成情况:"
            prop="completeSituation"
          >
            <el-input
              type="textarea"
              rows="3"
              placeholder="请输入"
              v-model="baseInForm.completeSituation"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
          class="textArea"
          style="width: 100%"
          label="问题描述:"
          prop="describe"
        >
          <div id="eidtContent_zh-CN"></div>
          </el-form-item>-->
        </el-form>
      </el-tab-pane>
      <!-- =====跟进记录===== -->
      <el-tab-pane
        label="跟进记录"
        name="two"
      >
        <div class="glo_Table">
          <el-table
            header-align="center"
            ref="mytable4"
            :data="tableData4"
            border
            stripe
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <!-- <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>-->
            <template v-for="(item, index) in myTableHeard4">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                :min-width="item.width"
                v-if="item.field == 'imgs'"
              >
                <template slot-scope="scope">
                  <div
                    class="lookImgsDIV"
                    @click="looksimgs(scope.row)"
                  >查看图片</div>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- =====责任核定===== -->
      <el-tab-pane
        label="责任核定"
        name="three"
      >
        <div class="formbox">
          <el-form
            :model="baseInForm2"
            ref="baseInFormRef"
            label-width="110px"
            class="glo_formBox"
            disabled
          >
            <el-form-item
              label="核定人:"
              prop="handleUserId"
              style="width: 320px"
            >
              <el-select
                v-model="baseInForm2.handleUserId"
                placeholder="请选择"
                @change="changeUser"
              >
                <el-option
                  v-for="item in employeeList"
                  :key="item.documentId"
                  :label="item.name"
                  :value="item.documentId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="核定时间:"
              prop="handleTime"
              style="width: 320px"
            >
              <el-date-picker
                v-model="baseInForm2.handleTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
            <div
              class="uploadBox"
              style="width: 100%"
            >
              <div class="uploadItem">
                <div
                  class="uploadLaber"
                  style="margin-right: 10px"
                >核定图片:</div>
                <!-- <uploadimgs
                  @input="changeFileList"
                  :fileNameLists="fileNameLists"
                  :limit="9"
                ></uploadimgs> -->
                <el-image
                  v-for="(itemA, idxA) in fileNameLists"
                  :key="idxA"
                  style="width:150px;height:150px;margin-right:10px;margin-top:10px;"
                  :src="itemA.url"
                  :preview-src-list="imgsList"
                ></el-image>
              </div>
            </div>
            <el-form-item
              class="textArea"
              style="width: 100%;margin-top:16px;"
              label="核定描述:"
              prop
            >
              <el-input
                type="textarea"
                rows="3"
                placeholder="请输入"
                v-model="baseInForm2.handleDescribe"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="赔款金额:"
              style="width: 320px"
            >
              <el-input
                v-model="baseInForm2.indemnityAmount"
                placeholder="自动带出"
                disabled
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div
          class="glo_Table"
          style="margin-top: 20px"
        >
          <div class="h3title">
            <div class="titles">责任核定</div>
            <div class="iconBox">
              <!-- <el-button class="glo_bgcMainColor" @click="addIcon()"
                >添加责任人</el-button
              >-->
            </div>
          </div>

          <el-table
            :data="tableData2"
            v-if="tableData2"
            border
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop
              label="责任对象"
              width="300px"
            >
              <template slot-scope="scope">
                <div class="twoInput">
                  <!-- 结算对象类型 -->
                  <el-select
                    v-model="tableData2[scope.$index].objectStatusConfDictId"
                    placeholder="请选择"
                    @change="changeObjestStatusYS($event, scope.$index)"
                    clearable
                    disabled
                  >
                    <el-option
                      v-for="item in objectStatusList"
                      :key="item.confDictId"
                      :label="item.val"
                      :value="item.confDictId"
                    ></el-option>
                  </el-select>
                  <!-- 结算对象 -->
                  <el-select
                    v-model="tableData2[scope.$index].objectName"
                    disabled
                    clearable
                    filterable
                    allow-create
                    @change="changeobjectName1($event, scope.$index)"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in tableData2[scope.$index]
                        .CustomerListsYF"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="责任比例"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="tableData2[scope.$index].dutyRatio"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="责任金额"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="tableData2[scope.$index].amount"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="付款方式"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="tableData2[scope.$index].paymentMethodConfDictId"
                  clearable
                  disabled
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in settlement_methodList"
                    :key="item.confDictId"
                    :label="item.val"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="收支类型"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="tableData2[scope.$index].inoutStatus"
                  clearable
                  placeholder="请选择"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in inoutStatusList"
                    :key="index"
                    :label="item.name"
                    :value="item.val"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="是否生成财务单据"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="tableData2[scope.$index].isFinance"
                  clearable
                  placeholder="请选择"
                  disabled
                >
                  <el-option
                    v-for="item in isFinanceList"
                    :key="item.val"
                    :label="item.name"
                    :value="item.val"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="备注"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="tableData2[scope.$index].remarks"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="" label="操作">
              <template slot-scope="scope">
                <i
                  style="font-size: 30px; margin-left: 10px"
                  class="el-icon-delete"
                  @click="delIcon(scope.$index)"
                ></i>
              </template>
            </el-table-column>-->
          </el-table>
          <div
            class="h3title"
            style="margin-top:16px;"
            v-if="tableData1.length"
          >
            <div class="titles">车辆核定</div>
          </div>
          <el-table
            :data="tableData1"
            v-if="tableData1.length"
            border
            style="margin-top:16px;width: 100%;"
          >
            <el-table-column
              align="center"
              prop
              label="责任对象"
              width="300px"
            >
              <template slot-scope="scope">
                <!-- 结算对象类型 -->
                <el-input
                  v-model="tableData1[scope.$index].objectNumber"
                  disabled
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="金额"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="tableData1[scope.$index].amount"
                  disabled
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="付款方式"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="tableData1[scope.$index].paymentMethodConfDictId"
                  disabled
                >
                  <el-option
                    v-for="item in settlement_methodList"
                    :key="item.confDictId"
                    :label="item.val"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="收支类型"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="tableData1[scope.$index].inoutStatusShow"
                  disabled
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="备注"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="tableData1[scope.$index].remarks"
                  disabled
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
          <el-form
            label-width="110px"
            class="glo_formBox"
            style="margin-top:16px;"
          >
            <el-form-item
              label="操作人:"
              prop="aaa"
              style="width: 320px"
            >
              <el-input
                v-model="baseInForm.createUserName"
                placeholder="自动带出"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              label="操作时间:"
              prop="aaa"
              style="width: 320px"
            >
              <el-input
                v-model="baseInForm.createTime"
                placeholder="自动带出"
                disabled
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

    <bigimgs
      :bigImgsShow="bigImgsShow"
      :srcList="srcList"
      @closeDialog="closeDialog"
    ></bigimgs>
  </div>
</template>
<script>
import bigimgs from '@/components/lookBigImgs.vue'
import uploadimgs from '@/components/upLoadImgs.vue'
export default {
  components: { bigimgs, uploadimgs },
  data() {
    return {
      tableData1: [],
      activeName: 'one',
      bigImgsShow: false,
      srcList: [],
      tableData4: [],
      myTableHeard4: [
        {
          name: '处理人',
          field: 'handleUserName',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '处理时间',
          field: 'handleTime',
          width: '160',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '处理描述',
          field: 'handleDescribe',
          width: '190',
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        // {
        //   name: "原运单号",
        //   field: "number",
        //   width: "160",
        //   sort: 4,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        // },
        {
          name: '创建时间',
          field: 'createTime',
          width: '120',
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '创建人',
          field: 'createUserName',
          width: '120',
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '图片',
          field: 'imgs',
          width: '180',
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],

      exceptionId: '',
      number: '',
      baseInForm: {
        number: '',
        applyDeptId: '',
        applyDeptName: '',
        applyUserId: '',
        applyUserName: '',
        describe: '',
        documentNumber: '',
        documentStatus: '',
        exceptionTypeConfDictId: '',
        exceptionTypeName: '',
        fileIds: [],
        handleProposal: '',
        happenTime: '',
        indemnityAmount: '',
        objectName: '',
        objectNumber: '',
        objectStatusConfDictId: '',
        outgoingCarrierId: '',
        outgoingCarrierName: '',
        outgoingNumber: '',
        paymentMethodConfDictId: '',
        planHandleDeptId: '',
        planHandleDeptName: '',
        planHandleUserId: '',
        planHandleUserName: '',
      },

      exception_type_list: [],
      objectStatusList: [],
      settlement_methodList: [],
      document_Status_list: [],
      handle_status_list: [],
      fileNameLists: [],
      employeeList: [],
      wayBillList: [],
      CarrierLists: [],
      depList: [],
      CustomerListsYF: [],

      baseInForm2: {
        handleUserName: '',
        handleUserId: '',
        handleTime: '',
        handleDescribe: '',
        fileIds: [],
      },
      tableData2: [],
      inoutStatusList: [
        {
          name: '收入',
          val: 'shou_ru:deal_status',
        },
        {
          name: '支出',
          val: 'zhi_chu:deal_status',
        },
      ],
      isFinanceList: [
        {
          name: '是',
          val: '1',
        },
        {
          name: '否',
          val: '0',
        },
      ],
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getDepList()
    this.getConfDictValDownList('object_status')
    this.getObjectUserDownLists('employee')
    this.getStatusValList('bill_tms_waybill_exception_v3.document_status')
    this.getStatusValList('bill_tms_waybill_exception_v3.handle_status')
    this.getConfDictValDownList('exception_type')
    this.getConfDictValDownList('settlement_method')
  },
  activated() {
    let exceptionId = this.$route.query.exceptionId || ''
    let number = this.$route.query.number || ''
    if (exceptionId) {
      this.exceptionId = exceptionId
      this.number = number
      this.getDetails()
      //   this.$API
      //     .getExceptionDutyDetail({ exceptionId: exceptionId })
      //     .then((res) => {
      //       console.log(res, "res");
      //       this.baseInForm = res.data.result;
      //     });
    }
  },
  destroyed() {},
  methods: {
    // 新建责任对象
    addIcon(idx) {
      let datas = JSON.parse(JSON.stringify(this.tableData2)) || []
      let objs = {
        amount: '',
        dutyId: '',
        dutyRatio: '',
        inoutStatus: '',
        isFinance: '1',
        objectName: '',
        objectNumber: '',
        objectStatusConfDictId: '',
        operationType: 'ADD',
        paymentMethodConfDictId: '',
        remarks: '',
        CustomerListsYF: [],
        objectStatusType: '',
      }
      datas.push(objs)
      this.tableData2 = datas
    },
    // 删除责任对象
    delIcon(idx) {
      this.$confirm('是否删除该责任人', '提示:')
        .then(() => {
          let datas = JSON.parse(JSON.stringify(this.tableData2)) || []

          if (datas[idx].operationType !== 'ADD') {
            datas[idx].operationType = 'DEL'
            this.DelTableData2.push(datas[idx])
          }
          datas.splice(idx, 1)
          this.tableData2 = datas
        })
        .catch(() => {})
    },

    getDetails() {
      this.fileNameLists = []
      this.imgsList = []
      this.$API
        .wtl_getExceptionDetail({ exceptionId: this.exceptionId })
        .then((res) => {
          this.baseInForm = res.data.result
          if (res.data.result && res.data.result.fileVos) {
            let arrs = res.data.result.fileVos.map((item) => {
              let objs = {
                name: item.fileId,
                url: item.fileUrl,
              }
              return objs
            })
            this.fileNameLists = arrs
            this.imgsList = arrs.map((item) => {
              return item.url
            })
          }
        })
    },

    // 获取业务部门
    getDepList() {
      this.$COMAPI.getDeptList().then((res) => {
        this.depList = res || []
      })
    },
    // 选择结算对象类型(应收
    changeObjestStatusYS(e) {
      console.log(e)
      this.baseInForm.objectName = ''
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.confDictId == e) {
            this.objectStatusType = item.key
          }
        })
        //
        this.getObjectUserDownListYf()
      } else {
        this.baseInForm.objectName = ''
        this.baseInForm.objectNumber = ''
        this.baseInForm.objectStatusConfDictId = ''
      }
    },
    // 获取承运商列表
    getCarrierList(carrierName) {
      this.$API
        .CarrierList({
          pageStart: 1,
          pageTotal: 200,
          carrierName: carrierName || '',
        })
        .then((res) => {
          this.CarrierLists = res.data.result.data || []
        })
    },
    // s申请人
    changeUserA(e) {
      if (e) {
        this.employeeList.forEach((item) => {
          if (item.documentId == e) {
            this.baseInForm.applyUserName = item.name
          }
        })
      } else {
        this.getCarrierList()
        this.baseInForm.applyUserName = ''
      }
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.objectStatusType,
          name: name || '',
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || []
        })
    },
    changeobjectName1(e) {
      if (!e) {
        this.getObjectUserDownListYf()
        this.baseInForm.objectNumber = ''
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.baseInForm.objectNumber = item.number
            // this.baseInForm.objectStatusConfDictId = item.documentId;
          }
        })
      }
    },
    // 选择承运商
    changeCarrier(e) {
      if (e) {
        this.CarrierLists.forEach((item) => {
          if (item.carrierName == e) {
            this.baseInForm.outgoingCarrierId = item.carrierId
          }
        })
      } else {
        this.getCarrierList()
      }
    },
    // 选择计划处理人
    changeUser(e) {
      if (e) {
        this.employeeList.forEach((item) => {
          if (item.documentId == e) {
            this.baseInForm.planHandleUserName = item.name
          }
        })
      } else {
        this.getCarrierList()
        this.baseInForm.planHandleUserName = ''
      }
    },
    // 运单
    getWaybillNumber(val) {
      this.$API
        .wtl_getWaybillList({
          pageStart: 1,
          pageTotal: 50,
          waybillNumber: val,
        })
        .then((res) => {
          this.wayBillList = res.data.result.data || []
        })
    },

    getNumbers(e) {
      if (
        this.baseInForm.documentStatus ==
        'bill_tms_waybill_split_v3:document_status'
      ) {
        this.getWaybillNumber(e)
      }
    },
    getObjectUserDownLists(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == 'employee') {
          // 获取员工列表
          this.employeeList = res || []
        }
      })
      // this.$COMAPI.getObjectUserDownList("employee").then(res=>{}); //获取员工列表
      // this.$COMAPI.getObjectUserDownList("dept").then(res=>{}); //获取部门列表
      // this.$COMAPI.getObjectUserDownList("storage").then(res=>{}); //获取网点列表
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array
    },
    // 状态下拉列表
    getStatusValList(key) {
      this.$TOOLS.getStatusValList(key).then((res) => {
        // 单据类型
        if (key == 'bill_tms_waybill_exception_v3.document_status') {
          this.document_Status_list = res || []
        }
        // 处理状态
        if (key == 'bill_tms_waybill_exception_v3.handle_status') {
          this.handle_status_list = res || []
        }
      })
    },
    // 字典类型
    getConfDictValDownList(key) {
      this.$COMAPI.getConfDictValDownList(key).then((res) => {
        if (key == 'exception_type') {
          //异常类型
          this.exception_type_list = res || []
        }
        if (key == 'object_status') {
          // 获取结算对象类型
          this.objectStatusList = res
        }
        if (key == 'settlement_method') {
          // 获取付款方式
          this.settlement_methodList = res
        }
      })
    },
    // 选择单据类型
    changeDocStatus(e) {
      console.log('e', e)
      if (e == 'bill_tms_waybill_split_v3:document_status') {
        this.getWaybillNumber()
      } else {
        this.wayBillList = []
        this.baseInForm.documentNumber = ''
      }
    },
    // 选择异常类型
    changeexceptionTypeName(e) {
      if (e) {
        this.exception_type_list.forEach((item) => {
          if (item.confDictId == e) {
            this.baseInForm.exceptionTypeName = item.key
          }
        })
      } else {
        this.baseInForm.exceptionTypeName = ''
      }
    },
    tabsClick(e) {
      if (e.name == 'two') {
        this.getData1()
      }
      if (e.name == 'three') {
        this.getData3()
      }
    },

    getData3() {
      this.$API
        .getExceptionDutyDetail({ exceptionId: this.exceptionId })
        .then((res) => {
          console.log(res, 'res')

          let result = res.data.result || ''
          let datas = []
          let fileVos = []
          if (result) {
            this.baseInForm2 = result
          }
          if (result && result.dutyVos) {
            datas = res.data.result.dutyVos || []
          }
          if (result && result.fileVos) {
            fileVos = res.data.result.fileVos || []
          }

          datas.forEach((item) => {
            item.operationType = 'UPDATE'
          })
          this.tableData2 = datas
          if (result && result.carCostVos) {
            this.tableData1 = res.data.result.carCostVos || []
          }

          let arrs = []
          fileVos.forEach((item) => {
            arrs.push({
              name: item.fileId,
              url: item.fileUrl,
              operationType: 'UPDATE',
            })
          })
          this.fileNameLists = arrs
          this.fileNameLists2 = arrs.map((item) => {
            return item.name
          }) //记录原来的
        })
    },
    // 获取异常详情-跟进记录
    getData1() {
      this.$API
        .wtl_getExceptionHandelRecord({ exceptionId: this.exceptionId })
        .then((res) => {
          this.tableData4 = res.data.result || []
        })
    },
    // 查看图片
    looksimgs(row) {
      console.log(row)
      let fildList = row.fileIds || []
      if (fildList.length > 0) {
        let ids = fildList.map((item) => {
          return item
        })
        this.$API.getFileUrlMore({ fileNames: ids }).then((res) => {
          console.log('res', res)
          let srcLists = res.data.result || []
          let arr1 = srcLists.map((imtes) => {
            return imtes.url
          })
          this.srcList = arr1
          this.bigImgsShow = true
        })
      } else {
        this.$message.error('没有图片哦')
      }

      //
    },
    closeDialog(e) {
      this.bigImgsShow = false
    },
  },
}
</script>
<style scoped lang='less'>
.lookImgsDIV {
  color: blue;
  cursor: pointer;
}

/deep/.el-input.is-disabled .el-input__inner {
  color: #333 !important;
}

.textArea {
  height: auto !important;
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
  color: #000 !important;
  font-weight: bold;
  font-size: 18px;
}

.twoInput {
  display: flex;
}
.h3title {
  .titles {
    font-size: 18px;
    font-weight: bold;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  font-weight: bold;
  // margin-bottom: 10px;
}
</style>